import styled from 'styled-components'
import NoLayersAlert from '../../components/no-layers-alert'

export const NoLayers = styled(NoLayersAlert)`
    grid-column: span 8;
`
